import { CancelTokenSource } from "axios";
import { IErrorModel } from "../models/DTO/ErrorModel";
import React, { ReactElement, ReactNode, createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

export type ApiErrorContextType = {
    ApiError?: IErrorModel,
    cancelTokenSource?: CancelTokenSource,
    UpdateErrorState?: (error?: IErrorModel) => void,
    UpdateTokenSource?: (tokenSource?: CancelTokenSource) => void,
    CancelRequest?: () => void,
}

const DefaultContext: ApiErrorContextType = {}

const ApiErrorContext = createContext<ApiErrorContextType>(DefaultContext);

export const ApiErrorProvider = ({ cancelTokenSource, error, children }: { cancelTokenSource?: CancelTokenSource, error?: IErrorModel, children?: ReactNode }): ReactElement => {

    const [apiError, setApiError] = useState<IErrorModel | undefined>(error),
        [cts, setCts] = useState<CancelTokenSource | undefined>(cancelTokenSource),
        cancelRequest: () => void = useCallback(() => cts?.cancel(), []),
        updateErrorState: (error?: IErrorModel) => void = useCallback((error) => {
            if (error != null)
                cancelRequest();

            setApiError(error);
        }, []),
        updateCancelTokenSource: (cts?: CancelTokenSource) => void = useCallback((cts) => setCts(cts), []),
        ctx: ApiErrorContextType = useMemo(() => (
            {
                ApiError: apiError,
                cancelTokenSource: cts,
                UpdateErrorState: updateErrorState,
                UpdateTokenSource: updateCancelTokenSource,
                CancelRequest: cancelRequest
            }), [apiError, cts, updateErrorState, updateCancelTokenSource, cancelRequest]);


    return (
        <ApiErrorContext.Provider value={ctx}>
            {children}
        </ApiErrorContext.Provider>
    )
}

export default ApiErrorContext;